import { Component, Input, OnInit, output, input, ChangeDetectionStrategy } from '@angular/core'; // ###
import { MatFormFieldModule } from '@angular/material/form-field';
import { CommonModule } from '@angular/common';
import { JkBaseComponent } from '../jkbase/jkbase.component';
import { MatGridListModule } from '@angular/material/grid-list';
import { FormsModule } from '@angular/forms';
import { MaterialModule } from '../../material.module';
import { JkfieldlabelComponent } from '../jkfieldlabel/jkfieldlabel.component';
import { jkLib } from '../../services/jkCommon';


/**
 * @component JkeditComponent
 * @description 一個可自訂的文字輸入 Angular 組件，繼承自 JkBaseComponent。
 * 提供多種輸入類型、長度限制、輔助文字和值變更事件。
 *
 * @example
 * ```html
 * <app-jkedit
 *   [value]="myValue"
 *   (valueChange)="onValueChange($event)"
 *   [maxlength]="50"
 *   [type]="'text'"
 *   [helperText]="'請輸入您的名稱'"
 *   [counter]="true">
 * </app-jkedit>
 * ```
 */
@Component({
  selector: 'app-jkedit',
  templateUrl: './jkedit.component.html',
  styleUrls: ['./jkedit.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    FormsModule,
    MatFormFieldModule,
    //JkBaseComponent,
    CommonModule,
    MaterialModule,
    JkfieldlabelComponent,
    MatGridListModule,
  ],
})
export class JkeditComponent extends JkBaseComponent implements OnInit {
  override comType: string = 'jkedit';
  inputType: string = 'text';
  /**
   * @property {number} maxlength
   * @description 輸入欄位的最大字元數。
   * @default 255
   */
  readonly maxlength = input<number>(255);
  /**
   * @property {string} type
   * @description 輸入欄位的類型。
   * @default 'text'
   * @options "text" | "password" | "email" | "number" | "tel" | "url"
   */
  readonly type = input<string>('text'); // "text" ｜ "password" ｜ "email" ｜ "number" ｜ "tel" ｜ "url"
  /**
   * @property {string} labelPlacement
   * @description 標籤的顯示位置。
   * @default 'fixed'
   * @options "end" | "fixed" | "floating" | "stacked" | "start"
   */
  readonly labelPlacement = input('fixed'); // "end" ｜ "fixed" ｜ "floating" ｜ "stacked" ｜ "start"
  /**
   * @property {string} helperText
   * @description 顯示在輸入欄位下方的輔助文字。
   */
  readonly helperText = input('');
  /**
   * @property {boolean} counter
   * @description 是否顯示字數計數器。
   * @default true
   */
  readonly counter = input(true);
  override flexStyle: any = { display: 'flex' };
  /**
   * @property {string} value
   * @description 輸入欄位的目前值。
   */
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input() value: string = '';
  /**
   * @event valueChange
   * @description 當輸入欄位的值發生變更時觸發的事件。
   * @outputs {string} 新的輸入值。
   */
  readonly valueChange = output<string>();
  /**
   * @method onValueChange
   * @description 當使用者輸入時呼叫此方法，用以更新 `value` 屬性並觸發 `valueChange` 事件。
   * @param {Event} newValue - 輸入事件物件。
   */
  onValueChange(newValue: Event) {
    if (newValue && newValue.target) {
      // this._value = newValue.target.value; 也可以
      //this.value = (newValue.target as HTMLInputElement).value;
    }
    if (this.valueChange)
      this.valueChange.emit(this.value);
  }

  /**
   * @property {boolean} autocomplete
   * @description 是否啟用瀏覽器的自動完成功能。
   * @default false
   */
  readonly autocomplete = input(false);
  constructor() {
    super();
  }

  override ngOnInit() {
    super.ngOnInit();
    this.inputType = this.type();
  }

  togglePasswordVisibility(event: Event) {
    event.stopPropagation();
    this.inputType = this.inputType === 'password' ? 'text' : 'password';
  }
  /**
   * @method addWhere
   * @description 根據輸入欄位的值，將條件附加到現有的 WHERE 查詢字串中。
   * @param {string} where - 現有的 WHERE 查詢字串。
   * @param {string} fieldName - 要篩選的資料庫欄位名稱。
   * @param {string} [condition='='] - 篩選條件 (例如: '=', 'LIKE', '>')。
   * @returns {string} 更新後的 WHERE 查詢字串。
   */
  addWhere(where: string, fieldName: string, condition: string = '='): string {
    if (this.value) {
      //where += ' AND ('+fieldName + ' = ' + jkLib.quotedStr(this.value)+') ';
      where = jkLib.text2Where(this.value, where, fieldName, condition);
    }
    return where;
  }
}
